import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* checkAssignmentBalance({ payload: { values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.check_balance, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.checkAssignmentBalanceDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.checkAssignmentBalanceFailed,
      handledErrors,
      endpoint: api.modifiers.assignments.check_balance.url
    });
  }
}

export const checkAssignmentBalanceSaga = takeEvery(
  types.CHECK_ASSIGNMENT_BALANCE_REQUEST,
  checkAssignmentBalance
);